<template>
    <p>At CU I was hired as a course assistant for intro to computer science classes. Here I hosted group office hours to assist students in learning introductory computer science concepts. This was my first payed job involving computer science, and I couldn't have been more thrilled!</p>
    <logo-scroller :logos="logos"><p>Tech used:</p></logo-scroller>
</template>

<script>
    import LogoScroller from '@/components/LogoScroller'

    export default {
        name: "CourseAssistantTimeline",
        components: {
            LogoScroller
        },
        data () {
            return {
                logos: [
                    'c++',
                    'python'
                ]
            } 
        },
        computed: {

        },
        methods: {

        }    
    }
</script>

<style>

</style>